import { useHistory } from 'react-router-dom'
import { useRef } from 'react'
import FormState from '../model/FormState'
import { Button } from './button'

export default function FormStep3(
    props: {setTab: any, formState: FormState, set: any}
) {
    const { setTab, formState, set } = props
    const form = useRef<HTMLFormElement>(null)
    const history = useHistory()

    const onSubmit = (event: any) => {
        event.preventDefault()
        if (form?.current?.checkValidity() !== false) {
            setTab(4)
        }
        form?.current?.classList.add('was-validated')
    }

    const voltar = () => {
        setTab(2)
    }

    const cancelar = () => {
        history.push('/buscar')
    }

    return (
        <form noValidate onSubmit={onSubmit} ref={form}>
            <div className="form-row">
                <div className="col-md-9 mb-3">
                    <label htmlFor="inputLogradouro">Logradouro</label>
                    <input
                        type="text"
                        className="form-control"
                        id="inputLogradouro"
                        placeholder="Logradouro"
                        value={formState.logradouro}
                        onChange={(e) => {set('setLogradouro', e.target.value)}}
                        required
                        minLength={5}
                    />
                    <div className="invalid-feedback">
                        Informe o logradouro
                    </div>
                </div>
                <div className="col-md-3 mb-3">
                    <label htmlFor="inputNumero">Número</label>
                    <input
                        type="number"
                        className="form-control"
                        id="inputNumero"
                        placeholder="Número"
                        value={formState.numero}
                        onChange={(e) => {set('setNumero', e.target.value)}}
                        required
                    />
                    <div className="invalid-feedback">
                        Informe o número
                    </div>
                </div>
            </div>
            <div className="form-row">
                <div className="col-md-7 mb-3">
                    <label htmlFor="inputBairro">Bairro</label>
                    <input
                        type="text"
                        className="form-control"
                        id="inputBairro"
                        placeholder="Bairro"
                        value={formState.bairro}
                        onChange={(e) => {set('setBairro', e.target.value)}}
                        required
                        minLength={5}
                    />
                    <div className="invalid-feedback">
                        Informe o bairro
                    </div>
                </div>
                <div className="col-md-5 mb-3">
                    <label htmlFor="inputCidade">Cidade</label>
                    <input
                        type="text"
                        className="form-control"
                        id="inputCidade"
                        placeholder="Cidade"
                        value={formState.cidade}
                        onChange={(e) => {set('setCidade', e.target.value)}}
                        required
                        minLength={2}
                    />
                    <div className="invalid-feedback">
                        Informe a cidade
                    </div>
                </div>
            </div>
            <div className="form-row">
                <div className="col-md-5 mb-3">
                    <label htmlFor="inputComplemento">Complemento</label>
                    <input
                        type="text"
                        className="form-control"
                        id="inputComplemento"
                        placeholder="Complemento"
                        value={formState.complemento}
                        onChange={(e) => {
                            set('setComplemento', e.target.value)
                        }}
                        required
                        minLength={2}
                    />
                    <div className="invalid-feedback">
                        Informe um complemento
                    </div>
                </div>
            </div>
            <div
                className="form-row justify-content-end mt-2"
            >
                <button type="button" onClick={cancelar} className="btn mr-2">
                    Cancelar
                </button>
                <button type="button" onClick={voltar} className="btn mr-2">
                    Voltar
                </button>
                <Button type="submit" className="ml-2">
                    Próximo
                    <i className="fas fa-chevron-right fa-sm ml-2" />
                </Button>
            </div>
        </form>
    )
}
